module.exports = __webpack_public_path__ + "img/news.898bc29e.svg";